import {createReducer, on} from '@ngrx/store';
import {BenutzerProfilEinstellungenApiModel} from 'cargo-hub-ui-customer-api';
import {RollenzuweisungApiModelInternal} from 'cargo-hub-ui-internal-api';
import {User} from '../../services/auth/userEntity';
import {RouterHelper} from '../../util/router-helper';
import {
  authInitAction,
  changeUserProfileSettings,
  changeUserProfileSettingsFailure,
  loadUserProfileSettingsFailure,
  loadUserProfileSettingsSuccess,
  loggedInAction,
  logoutAction,
  newContextAction,
  queryRoleAssignationsSuccess,
  setDesiredRedirectAction,
  updateCurrentDatetime,
  updateOnlineStatus,
  zkkSelectedAction
} from './auth.actions';

export interface AuthState {
  currentUser: User | null;
  roleAssignations?: RollenzuweisungApiModelInternal;
  redirectAfterLogin: string | null;
  /**
   * DateTime is stored in ISO format.
   * Not directly related to auth State could be refactored to a better place when available.
   */
  currentDateTime: string | null;
  /**
   * Whether internet connection is currently available.
   * Not directly related to auth State could be refactored to a better place when available.
   */
  online: boolean;
  profileSettings: BenutzerProfilEinstellungenApiModel | null;
  profileSettingError: Error | null;
}

export const initialState: AuthState = {
  currentUser: null,
  redirectAfterLogin: null,
  currentDateTime: null,
  online: true,
  profileSettings: null,
  profileSettingError: null
};

export const authReducer = createReducer(
  initialState,
  on(authInitAction, (state, action) => ({
    ...state,
    currentDateTime: action.isoDateTime,
    online: action.online
  })),
  on(loggedInAction, (state, action) => ({
    ...state,
    currentUser: action.payload
  })),
  on(queryRoleAssignationsSuccess, (state, action) => ({
    ...state,
    currentUser: state.currentUser
      ? {
          ...state.currentUser,
          cdRoles: [...(action.response.rollenzuweisungenIntern ?? [])]
        }
      : null,
    roleAssignations: action.response
  })),
  on(zkkSelectedAction, (state, action) => ({
    ...state,
    currentUser: state.currentUser
      ? {
          ...state.currentUser,
          activePartner: action.newPartner,
          cdRoles: [...(state.roleAssignations?.rollenzuweisungenIntern ?? []), ...(state.roleAssignations?.rollenzuweisungenKunde?.find(a => a.zkk === action.newPartner.partnerId)?.rollen ?? [])]
        }
      : null
  })),
  on(setDesiredRedirectAction, (state, action) => ({
    ...state,
    redirectAfterLogin: action.url
  })),
  on(logoutAction, state => ({
    ...state,
    currentUser: null
  })),
  on(loadUserProfileSettingsSuccess, (state, action) => ({
    ...state,
    profileSettings: action.payload
  })),
  on(loadUserProfileSettingsFailure, (state, action) => ({
    ...state,
    profileSettingError: action.error
  })),
  on(newContextAction, state => ({
    ...state,
    redirectAfterLogin: RouterHelper.removeQuery(state.redirectAfterLogin),
    profileSettingError: initialState.profileSettingError,
    profileSettings: initialState.profileSettings
  })),
  on(changeUserProfileSettings, (state, action) => ({
    ...state,
    profileSettings: {...state.profileSettings, ...action.payload}
  })),
  on(changeUserProfileSettingsFailure, (state, action) => ({
    ...state,
    profileSettingError: action.error
  })),
  on(updateCurrentDatetime, (state, action) => ({
    ...state,
    currentDateTime: action.currentDatetime
  })),
  on(updateOnlineStatus, (state, action) => ({
    ...state,
    online: action.online
  }))
);
